import google from "@assets/integrations/google.svg";
import dotloop from "@assets/integrations/dotloop.svg";
import microsoft from "@assets/integrations/microsoft.svg";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";

const connectedAppsLogos = {
  google,
  dotloop,
  microsoft,
};

export type ConnectedAppsKeys = keyof typeof connectedAppsLogos | "smsChat";

export const getAppIcon = (appName: ConnectedAppsKeys) => {
  if (appName === "smsChat") {
    return <PhoneIphoneIcon />;
  }
  const logo = connectedAppsLogos[appName];
  return logo ? <img src={logo} /> : <HubOutlinedIcon />;
};

// Google and Microsoft are alternative email providers: a user may connect one or the other, never both at once.
const EMAIL_PROVIDER_APP_IDS = ["google", "microsoft"] as const;

export const getConnectedSibling = <
  T extends { id: string; name: string; connection: string },
>(
  apps: T[],
  appId: string,
) => {
  if (!(EMAIL_PROVIDER_APP_IDS as readonly string[]).includes(appId)) {
    return undefined;
  }
  return apps.find(
    (app) =>
      app.id !== appId &&
      (EMAIL_PROVIDER_APP_IDS as readonly string[]).includes(app.id) &&
      (app.connection === "connected" || app.connection === "connecting"),
  );
};

// export const getAppLabel = (connection: string | undefined) => {
//   const appLabels: Record<string, string> = {
//     connected: "Enabled",
//     "not-connected": "Disabled",
//     expired: "Expired",
//     connecting: "Enabling...",
//   };
//   return appLabels[connection ?? ""] ?? connection;
// };
